/**
 * WordPress dependencies
 */
import { __ } from "@wordpress/i18n";
import { registerFormatType, toggleFormat } from "@wordpress/rich-text";
import React from "react";
import { BlockControls } from "@wordpress/block-editor";
import { Toolbar, IconButton } from "@wordpress/components";

/**
 * Block constants
 */
const name = "advanced/highlight";

export const highlight = {
  name,
  title: __("Highlight"),
  tagName: "span",
  className: null,
  attributes: {
    style: "style",
  },
  edit({ isActive, value, onChange }) {
    const onToggle = () => {
      onChange(
        toggleFormat(value, {
          type: name,
          attributes: {
            style: "box-shadow: inset 0px -0.6em 0px #00ABE8;",
            class: "highlight",
          },
        })
      );
    };
    return (
      <BlockControls>
        <Toolbar>
          <IconButton
            icon="admin-appearance"
            title={__("Highlight")}
            onClick={onToggle}
            isActive={isActive}
          />
        </Toolbar>
      </BlockControls>
    );
  },
};

export default function registerHighlight() {
  [highlight].forEach(({ name, ...settings }) =>
    registerFormatType(name, settings)
  );
}
